import {COMPANIES, type User} from '@/domain/entities/User';

const ALWAYS_ALLOWED = [COMPANIES.ASEFOR, COMPANIES.GEOMATICO];

class UserPermissions {
  constructor(private me?: User) {}

  private get hasAlwaysAllowedOrganization(): boolean {
    if (!this.me) return false;
    return ALWAYS_ALLOWED.includes(this.me.organization);
  }

  hasPermissionToCutForestMass(): boolean {
    if (this.hasAlwaysAllowedOrganization) return true;
    return this.me?.organization === COMPANIES.FINSA;
  }

  hasPermissionToEditForestMass(): boolean {
    if (this.hasAlwaysAllowedOrganization) return true;
    return this.me?.organization === COMPANIES.FINSA;
  }

  hasPermissionToUploadUavCloudPoints(): boolean {
    if (this.hasAlwaysAllowedOrganization) return true;
    return this.me?.organization === COMPANIES.FORTOP;
  }

  hasPermissionToUploadSlamCloudPoints(): boolean {
    return this.hasAlwaysAllowedOrganization;
  }

  hasPermissionToDeleteUavCloudPoints(): boolean {
    if (this.hasAlwaysAllowedOrganization) return true;
    return this.me?.organization === COMPANIES.FORTOP;
  }

  hasPermissionToDeleteSlamCloudPoints(): boolean {
    return this.hasAlwaysAllowedOrganization;
  }

  hasPermissionToUploadPlotInventories(): boolean {
    return this.hasAlwaysAllowedOrganization;
  }

  hasPermissionToEditInventoryPlotRealWeight(): boolean {
    if (this.hasAlwaysAllowedOrganization) return true;
    return this.me?.organization === COMPANIES.FINSA;
  }

  hasPermissionToAddForestMass(): boolean {
    if (!this.me) return false;
    return this.me.organization !== COMPANIES.UVIGO;
  }
}

export default UserPermissions;
